


















































































































































import { Component } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import { ScrollButton } from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CallGroupFilter from "@/components/Call/Statistic/CallGroupFilter.vue";
import { timeFilter } from '@/utils/date-util';
import { CallGroupItem } from '@/store/call/statistic/types';
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({ components: {CallGroupFilter, ScrollButton, GroupCharts}})
export default class CallGroup extends BaseItemsPage<CallGroupItem> {

  @Getter("callStatisticGroup") responseItems?: CallGroupItem[];
  @Getter("callGroupBy") groupByList: any;

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData() {
    return this.responseItems;
  }

  get tableFieldsDefault() {
    let isShowFinInf: boolean = localStorage.getItem('show-finance-info') === 'true';
    let priceFields = ['partner_price', 'provider_price'];
    return [
      ...['finished', 'not_answered', 'buffered', 'failed', 'rejected', 'total', 'duration'],
      ...(isShowFinInf ? priceFields : [])
    ];
  }

  get totalData(): CallGroupItem {
    let total = {
      totalRow: 'This is the last row of the table',
      finished: 0,
      not_answered: 0,
      buffered: 0,
      failed: 0,
      rejected: 0,
      duration: 0,
      total: 0,
      partner_price: '0',
      provider_price: '0',
    };
    this.tableData.forEach( (row: CallGroupItem) => {
      total.finished += row.finished;
      total.not_answered += row.not_answered;
      total.failed += row.failed;
      total.rejected += row.rejected;
      total.buffered += row.buffered;
      total.duration += row.duration;
      total.total += row.total;
      total.partner_price = String((Number(row.partner_price) + Number(total.partner_price)).toFixed(2));
      total.provider_price = String((Number(row.provider_price) + Number(total.provider_price)).toFixed(2));
    });
    return total;
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

  formatDuration(val: number): string|undefined {
    return timeFilter(val)
  }
}
